function Loader() {
  return (
    <div className="loader">
      <div className="box"></div>
      <div className="circle"></div>
      <div className="triangle"></div>
    </div>
  );
}

export default Loader;
